import { createContext, Dispatch, SetStateAction } from 'react';

import { FormInstance } from 'antd';

import { CivilPaymentMethodForm, CivilQuotationForm } from './StepThreeFormProvider';

import { CivilQuotationComponent, CivilQuotationRequest, WebCivilQuotation } from '../../../../../../../../../shared/interfaces/services/civil-quotation-service';
import { GetCommertialsConditionsResponse } from '../../../../../../../../../shared/interfaces';
import { QuotationButton } from '../../../../../shared';

interface StepThreeFormContextProps {
  civilPaymentMethodsForm:          FormInstance<CivilPaymentMethodForm>;
  civilQuotationComponents:         Array<CivilQuotationComponent>;
  clearPrimaFieldsOnFormChange:     () => void;
  commertialConditions:             GetCommertialsConditionsResponse | undefined;
  generateCivilQuotationForm:       () => CivilQuotationRequest;
  labelButton:                      QuotationButton;
  quotationResponse:                WebCivilQuotation | undefined;
  setLabelButton:                   Dispatch<SetStateAction<QuotationButton>>;
  setQuotationResponse:             Dispatch<SetStateAction<WebCivilQuotation | undefined>>;
  stepThreeCivilQuotationForm:      FormInstance<CivilQuotationForm>;
  haveConsumedService:              boolean;
  setHaveConsumedService:           Dispatch<boolean>;
  createTabs:                       () => void;
  quotationTabs:                    any[];
  setQuotationTabs:                 React.Dispatch<React.SetStateAction<any[]>>;
  activeTab:                        any;
  setActiveTab:                     React.Dispatch<any>;
  handlerOnClick:                   () => Promise<void>
}

export const StepThreeFormContext = createContext(
  {} as StepThreeFormContextProps
);
